import { memo } from 'react';
// @mui
import { useTheme } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
// theme
import { bgBlur } from 'src/theme/css';
// hooks
import { useMockedUser } from 'src/hooks/use-mocked-user';
// components
import { NavSectionHorizontal } from 'src/components/nav-section';
// 
import { HEADER } from '../config-layout';
import { useNavData } from './config-navigation';
import { HeaderShadow } from '../_common';
import { useAuthContext } from 'src/auth/hooks';

// ----------------------------------------------------------------------

function NavHorizontal() {
  const theme = useTheme();
  const { user } = useAuthContext();
  
  
  // Determine the user's role based on flags
  const getUserRole = () => {
    if (user?.is_admin) return 'admin';
    if (user?.is_academic) return 'academic';
    if (user?.is_non_academic) return 'non_academic';   
    if (user?.is_student) return 'student';
    if (user?.is_parent) return 'parent';
    if (user?.is_height_student) return 'height_student';
    if (user?.is_outsider) return 'outsider';

    return null; 
  };

  const role = getUserRole(); 
  
  const navData = useNavData();

  return (
    <AppBar
      component="nav"
      sx={{
        top: HEADER.H_DESKTOP_OFFSET,
      }}
    >
      <Toolbar
        sx={{
          ...bgBlur({
            color: theme.palette.background.default,
          }),
        }}
      >
        <NavSectionHorizontal
          data={navData}
          config={{
            currentRole: role,
          }}
        />
      </Toolbar>
      <HeaderShadow />
    </AppBar>
  );
}

export default memo(NavHorizontal);
